import React, { useEffect, useMemo, useState } from "react"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../components/Common/TableContainer"
import * as Yup from "yup"
import { SaveToast } from "components/Common/SaveToast"
import Select from "react-select"
import moment from "moment"

import {
  Col,
  Row,
  Card,
  CardBody,
  Label,
  Input,
  FormFeedback,
  Button,
} from "reactstrap"
import { Form, Formik } from "formik"

import {
  SimpleStringValue,
  ArrayToStringValue,
} from "helpers/common_helper_functions"
import { getAllParticipantsByTP } from "helpers/backendHelpers/participants"
import { getAllTutors } from "helpers/backendHelpers/tutorManagement"
import {
  createTrainingBatch,
  getTrainingBatch,
  updateTrainingBatch,
} from "helpers/backendHelpers/trainingBatch"

function AddEditDetails(props) {
  document.title = "Batch | LMS Ghana"

  const tp_id = props.location?.state?.tp_id
  const [trainingParticipants, setTrainingParticipants] = useState([])
  const [loading, setLoading] = useState(false)
  const [tutors, setTutors] = useState([])
  const [values, setValues] = useState({})
  const [participantsId, setParticipantId] = useState([])
  const [temp, setTemp] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [batchId, setBatchId] = useState(0)
  const [isView, setIsView] = useState(false)
  const [flag, setFlag] = useState(0)
  const [batchIds, setBatchIds] = useState([])
  const [batchDetails, setBatchDetails] = useState({})
  const [pageIndex, setPageIndex] = useState(1)
  const [pageCount, setPageCount] = useState(30)
  const [limit, setLimit] = useState(100)
  const [totalRecords, setTotalRecords] = useState(0)

  useEffect(() => {
    // fetchAllTrainingParticipants(tp_id, isEdit ? 1 : 0)
    fetchTutors()
  }, [])

  const [form, setForm] = useState({
    tu_id: "",
    tb_dateTime: "",
  })

  useEffect(() => {
    if (batchId) {
      fetchAllTrainingParticipants(tp_id, 1, batchId)
    }
  }, [batchId])

  useEffect(() => {
    fetchAllTrainingParticipants(tp_id, 1, batchId)
  }, [pageIndex, limit])

  useEffect(() => {
    // document.getElementById("batch-creation").classList.add("mm-active")
    let { type, id } = props.match.params || {}
    setBatchId(parseInt(id))
  }, [])

  useEffect(() => {
    if (batchId) {
      fetchBatchCreationForEdit(batchId)
    }
  }, [batchId])

  useEffect(() => {
    batchIds &&
      batchIds.length > 0 &&
      batchIds.map(data => {
        return setValues(pre => ({
          ...pre,
          [`${data}`]: true,
        }))
      })
  }, [batchIds])

  const handleAllChecked = () => {
    batchIds &&
      batchIds.length > 0 &&
      batchIds.map(data => {
        setValues(pre => ({
          ...pre,
          [`${data}`]: true,
        }))
      })
    setTemp(!temp)
  }

  const fetchTutors = async () => {
    try {
      setLoading(true)
      let response = await getAllTutors()
      let { tutors } = response.data || {}
      tutors = tutors || []
      let tutorsName = []
      tutors.map(data => {
        let tutorObj = {
          key: data.tu_id,
          value: data.tu_fullName,
        }
        tutorsName.push(tutorObj)
      })
      setTutors(tutorsName)
      setLoading(false)
    } catch (error) {
      let message =
        error?.response?.data?.message ||
        error?.message ||
        "There Was A Problem Fetching Tutors1"
      setTutors([])
      setLoading(false)
      return SaveToast({ message, type: "error" })
    }
  }

  const fetchBatchCreationForEdit = async ct_id => {
    try {
      let response = await getTrainingBatch(ct_id)

      let { trainingBatch } = response.data || {}
      trainingBatch = trainingBatch || {}
      setBatchIds(
        trainingBatch?.tb_participants ? trainingBatch?.tb_participants : []
      )
      setForm(trainingBatch)
      setBatchDetails(trainingBatch)
      trainingBatch?.tb_participants &&
        trainingBatch?.tb_participants.map(data => {
          return setValues(pre => ({
            ...pre,
            [`${data}`]: true,
          }))
        })
      setTemp(pre => !pre)
    } catch (error) {
      let message =
        error?.response?.data?.message ||
        error?.message ||
        "There Was A Problem Fetching Content Team Details"

      setForm(form)
      return SaveToast({ message, type: "error" })
    }
  }

  const fetchAllTrainingParticipants = async (id, isEdit, batchId) => {
    try {
      setLoading(true)
      const response = await getAllParticipantsByTP(
        id,
        isEdit,
        batchId,
        pageIndex,
        limit
      )
      let { userDetails } = response.data || {}

      setTrainingParticipants(userDetails.rows)
      setTotalRecords(userDetails.count)
      let pageCount = Math.ceil(userDetails.count / limit)
      setPageCount(pageCount)
      setTemp(!temp)
      setLoading(false)
    } catch (error) {
      const message = error?.message || "There Was A Problem Fetching Content"

      setLoading(false)
      return SaveToast({ message, type: "error" })
    }
  }

  const handleSave = () => {
    let tempVals = Object.entries(values)
    let finalIds = []
    tempVals.map(([key, val]) => {
      if (val) {
        finalIds.push(key)
      }
    })
    form.tb_participants = finalIds.toString()
    form.tp_id = tp_id
    if (isEdit) {
      return handleEditBatchSubmit(form)
    } else {
      return handleAddBatchData(form)
    }
  }

  const handleAddBatchData = async form => {
    setLoading(true)
    let response = await createTrainingBatch(form)
    let message = response?.message || "Batch Created Successfully"
    SaveToast({ message, type: "success" })
    setLoading(false)
  }

  const handleEditBatchSubmit = async form => {
    if (!batchId) {
      return SaveToast({
        message: "Please enter Batch Id",
        type: "error",
      })
    }
    try {
      setLoading(true)
      const response = await updateTrainingBatch(batchId, form)
      let message = response?.message || "Batch Updated Successfully"
      SaveToast({ message, type: "success" })
      setLoading(false)
      props.history.push({
        pathname: "/batch-creation",
        state: { tp_id },
      })
    } catch (error) {
      let message =
        error?.response?.data?.message ||
        error?.message ||
        "There Was A Problem Updating Batch"
      setLoading(false)
      return SaveToast({ message, type: "error" })
    }
  }

  const toggleCheckbox = e => {
    setValues(pre => ({
      ...pre,
      [e.target.name]: e.target.checked,
    }))
    if (e.target.checked) {
      setParticipantId(pre => [...pre, parseInt(e.target.value)])
      setTemp(temp)
    } else {
      setParticipantId(pre => pre.filter(data => data != e.target.value))
    }
  }

  const columns = useMemo(
    () => [
      {
        Header: "User Name",
        accessor: "username",
        filterable: true,
        Cell: cellProps => {
          return <ArrayToStringValue {...cellProps} />
        },
      },
      {
        Header: "User Type",
        accessor: "userType",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "User Email",
        accessor: "userEmail",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Region",
        accessor: "userRegion",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "District",
        accessor: "userDistrict",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      {/* <Breadcrumbs title="Batch Creation" breadcrumbItem="Batch" /> */}
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <Formik
                    enableReinitialize={true}
                    initialValues={form}
                    validationSchema={Yup.object({
                      tu_id: Yup.string().required("Please Select Teacher"),

                      tb_dateTime: Yup.string().required(
                        "Please Select Date And Time"
                      ),
                    })}
                    onSubmit={values => {
                      let batchData = values

                      if (isEdit) {
                        return handleEditBatchSubmit(batchId, batchData)
                      } else {
                        return handleSave(batchData)
                      }
                    }}
                  >
                    {({
                      touched,
                      errors,
                      values,
                      handleSubmit,
                      handleBlur,
                      handleChange,
                      validateOnChange,
                    }) => (
                      <>
                        <Form
                          onSubmit={e => {
                            e.preventDefault()
                            handleSubmit(e)
                            return false
                          }}
                        >
                          <Row>
                            <Col>
                              <Row className="">
                                <Col md={4} sm={6} xs={12} className="mb-3">
                                  <Label className="form-label">Tutor</Label>
                                  <br />
                                  <span>{batchDetails?.tu_id}</span>
                                </Col>
                                <Col md={4} sm={6} xs={12} className="mb-3">
                                  <Label className="form-label">
                                    Date And Time{" "}
                                  </Label>

                                  <br />
                                  <span>
                                    {moment(batchDetails?.tb_dateTime).format(
                                      "YYYY/MM/DD HH:MM"
                                    )}
                                  </span>
                                </Col>
                                <Col md={4} sm={6} xs={12} className="mb-3">
                                  <Label className="form-label">
                                    Room Url{" "}
                                  </Label>

                                  <br />
                                  <span>{batchDetails?.tb_roomURL}</span>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Form>
                      </>
                    )}
                  </Formik>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  {batchIds && (
                    <TableContainer
                      columns={columns}
                      data={trainingParticipants}
                      isGlobalFilter={true}
                      isSelectAllOption={true}
                      isAddOptions={false}
                      addButtonLabel="Save Participants"
                      customPageSize={10}
                      className="custom-header-css"
                      canExportCsv={true}
                      canPrint={false}
                      handleAllChecked={handleAllChecked}
                      pageIndexFromApi={pageIndex}
                      setPageIndexFromApi={setPageIndex}
                      pageCountFromApi={pageCount}
                      setPageCount1={setPageCount}
                      totalRecords={totalRecords}
                      limit={limit}
                      setLimit={setLimit}
                      customPagination={true}
                      fetchColumnWiseSearchAPI=""
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className="mb-3 text-center">
            <Col>
              <Button
                size="md"
                color="primary"
                type="button"
                className="mx-2"
                onClick={() => {
                  props.history.push({
                    pathname: "/batch-creation",
                    state: { tp_id },
                  })
                }}
              >
                Back
              </Button>
            </Col>
          </Row>
        </div>
      </div>

      {/* </div>
      </div> */}
    </React.Fragment>
  )
}

export default AddEditDetails
